
<template>
    <v-app>
        <v-content class="pa-0" transition="slide-x-transition">
        <div id="nav"/>
            <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
@media (min-width: 1264px) {
  .container {
    max-width: 1275px;
  }
}
.swal2-popup {
    color: #000;
    width: 650px !important;
    background: #fff;
    font-family: 'UniversLTStd' !important;
    font-size: 16px;
}
.swal2-title{
    color: #000 !important;
    font-size: 16px !important;
}
.swal2-icon {
    width: 5em !important;
    height: 5em !important;
    color: #000 !important;
}
.swal2-icon.swal2-warning {
    border-color: #000 !important;
}
.swal2-styled.swal2-cancel {
    border: 1px solid #000 !important;
    border-radius: 0 !important;
    background: transparent !important;
    background-color: #fff !important;
    color: #000 !important;
    font-size: 16px !important;
    font-weight: bold !important;
}
.swal2-styled.swal2-cancel:hover, .swal2-styled.swal2-confirm:hover {
    box-shadow: 2px 2px 3px #ccc !important;
}
.swal2-styled:focus {
    box-shadow: none !important;
}
.swal2-styled.swal2-confirm {
    border: 0 !important;
    border-radius: 0 !important;
    background-color: #3a83c3 !important;
    color: #fff !important;
    font-size: 16px !important;
    font-weight: bold !important;
}
.swal2-close:hover {
    transform: none;
    background: 0 0;
    color: #000 !important;
}
.swal2-close:focus{
    outline: 0 !important;
}
.swal2-content{
    font-size: 18px !important;
    color: #000 !important;
    font-family: 'UniversLTStd' !important;
}
.swal2-html-container{
    font-weight: bold !important;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
    color: #000 !important;
    border-color:  #000 !important;
    background-color: #000 !important;
}
.swal2-icon.swal2-success .swal2-success-ring {
    border: .25em solid rgb(19, 19, 19) !important;
}
</style>
